import { DocumentAction, TemplateDocument } from '../types'
import {
  initDocumentSuccess,
} from '../actions';

const template = (state: TemplateDocument = null, action: DocumentAction): TemplateDocument => {
  switch (action.type) {
    case initDocumentSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

export default template;
